/**
 * Publish rejections carry actionable detail in two shapes:
 *   v1 (json-api):  { missing_sections: [{ section, label }], error }
 *   v2 (api-v2):    { success: false, errors: { <section>: ["<label> is required..."] } }
 * Prefer either over the generic fallback. `error.response` is absent on network
 * failures — never dereference it unguarded (see BUG-009).
 *
 * @param {unknown} error
 * @returns {string}
 */
export const getPublishErrorMessage = error => {
  const fallback = "Error submitting for review";
  const data = error?.response?.data;

  if (!data) {
    return fallback;
  }

  if (Array.isArray(data.missing_sections) && data.missing_sections.length) {
    const labels = data.missing_sections.map(item => item?.label).filter(Boolean);
    if (labels.length) {
      return `Please complete before publishing: ${labels.join(", ")}`;
    }
  }

  if (data.errors && typeof data.errors === "object") {
    const messages = Object.values(data.errors)
      .flatMap(value => (Array.isArray(value) ? value : [value]))
      .filter(item => typeof item === "string" && item.trim().length);
    if (messages.length) {
      return messages.join(" ");
    }
  }

  return data.error || data.message || fallback;
};
